import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember, jsonMapMember} from 'typedjson';
import {Serializers} from '@/utils/Serializers';

@jsonObject
export class EthernetSettings {

  @jsonMember({name: 'assignedMacAddress'})
  public AssignedMacAddress!: string;

  @jsonMember({name: 'autoNegotiate'})
  public AutoNegotiate!: boolean;

  @jsonMember({name: 'duplex'})
  public Duplex!: string;

  @jsonMember({name: 'generateMacAddressMask'})
  public GenerateMacAddressMask!: string;

  @jsonMember({name: 'macAddress'})
  public MacAddress!: string;

  @jsonArrayMember(String, {name: 'macAddressBlacklist'})
  public MacAddressBlacklist!: string[];

  @jsonMember({name: 'mtu'})
  public Mtu!: number;

  @jsonMember({name: 'port'})
  public Port!: string;

  @jsonMember({name: 's390NetType'})
  public S390NetType!: string;

  @jsonMapMember(String, String, {
    name: 's390Options',
    deserializer: Serializers.ObjectToMap,
    serializer: Serializers.MapToObject,
  })
  public S390Options!: Map<string, string>;

  @jsonArrayMember(String, {name: 's390SubChannels'})
  public S390SubChannels!: string[];

  @jsonMember({name: 'speed'})
  public Speed!: number;

  @jsonMember({name: 'wakeOnLan'})
  public WakeOnLan!: number;

  @jsonMember({name: 'wakeOnLanPassword'})
  public WakeOnLanPassword!: string;

  constructor(ethernetSettings?: EthernetSettings) {
    if (ethernetSettings) {
      this.AssignedMacAddress = ethernetSettings.AssignedMacAddress;
      this.AutoNegotiate = ethernetSettings.AutoNegotiate;
      this.Duplex = ethernetSettings.Duplex;
      this.GenerateMacAddressMask = ethernetSettings.GenerateMacAddressMask;
      this.MacAddress = ethernetSettings.MacAddress;
      if (ethernetSettings.MacAddressBlacklist) {
        this.MacAddressBlacklist = JSON.parse(JSON.stringify(ethernetSettings.MacAddressBlacklist));
      }
      this.Mtu = ethernetSettings.Mtu;
      this.Port = ethernetSettings.Port;
      this.S390NetType = ethernetSettings.S390NetType;
      if (ethernetSettings.S390Options) {
        this.S390Options = JSON.parse(JSON.stringify(ethernetSettings.S390Options));
      }
      if (ethernetSettings.S390SubChannels) {
        this.S390SubChannels = JSON.parse(JSON.stringify(ethernetSettings.S390SubChannels));
      }
      this.Speed = ethernetSettings.Speed;
      this.WakeOnLan = ethernetSettings.WakeOnLan;
      this.WakeOnLanPassword = ethernetSettings.WakeOnLanPassword;
    }
  }
}
